import React, {Component} from 'react';
import BaseElement from '../BaseElement/BaseElement';
import _ from 'lodash';
import {getDynamicRefById} from 'crazyEditor/core/elements/utils/elementRefUtils';
import CrossSellGallery, {crossSellGalleryBaseStyle} from './CrossSellGallery';

// this function exists so that the you can access the inner getPointerElementsStyles function through the element methods (see EditBox for usage)
export function getInteractiveElements(elementId) {
  const crossSellGalleryRef = _.get(getDynamicRefById(elementId), 'refs.crossSellGallery');
  if (crossSellGalleryRef) {
    return crossSellGalleryRef.getInteractiveElements();
  }
  return [];
}

export function refreshInteractiveElementsList(elementId, onComplete) {
  const crossSellGalleryRef = _.get(getDynamicRefById(elementId), 'refs.crossSellGallery');
  if (crossSellGalleryRef) {
    _.delay(crossSellGalleryRef.refreshInteractiveElementsList, 450, onComplete);
  }
}

export default class CrossSellGalleryElement extends Component {
  render() {
    return (
      <BaseElement {...this.props} style={{...crossSellGalleryBaseStyle, overflow: 'hidden'}}>
        <CrossSellGallery {...this.props} ref="crossSellGallery"/>
      </BaseElement>
    );
  }
}
